var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Switch } from "@mui/material";
import { useEditController } from "react-admin";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useTranslation } from "react-i18next";
// `??`, not `||`: disabling a channel stores `false`, and `false || true`
// reads back as enabled, so the online toggle could never be turned off.
var toTenantVotingChannels = function (channels) {
    var _a, _b, _c;
    return ({
        online: (_a = channels === null || channels === void 0 ? void 0 : channels.online) !== null && _a !== void 0 ? _a : true,
        kiosk: (_b = channels === null || channels === void 0 ? void 0 : channels.kiosk) !== null && _b !== void 0 ? _b : false,
        telephone: (_c = channels === null || channels === void 0 ? void 0 : channels.telephone) !== null && _c !== void 0 ? _c : false,
    });
};
var SettingsVotingChannelsStyles = {
    Wrapper: styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: flex;\n        flex-direction: column;\n    "], ["\n        display: flex;\n        flex-direction: column;\n    "]))),
    Content: styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        display: flex;\n        width: 239px;\n        align-items: center;\n        justify-content: space-between;\n    "], ["\n        display: flex;\n        width: 239px;\n        align-items: center;\n        justify-content: space-between;\n    "]))),
    Text: styled("span")(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        text-transform: capitalize;\n    "], ["\n        text-transform: capitalize;\n    "]))),
};
export var SettingsVotingChannels = function () {
    var tenantId = useTenantStore()[0];
    var t = useTranslation().t;
    var _a = useEditController({
        resource: "sequent_backend_tenant",
        id: tenantId,
        redirect: false,
        undoable: false,
    }), record = _a.record, save = _a.save, isLoading = _a.isLoading;
    var _b = useState(toTenantVotingChannels(record === null || record === void 0 ? void 0 : record.voting_channels)), voting = _b[0], setVoting = _b[1];
    var handleToggle = function (method) {
        var _a;
        var updatedVoting = __assign(__assign({}, voting), (_a = {}, _a[method] = !voting[method], _a));
        console.log("Update Voting", updatedVoting, method);
        setVoting(updatedVoting);
        if (save) {
            save({
                voting_channels: {
                    online: updatedVoting.online,
                    kiosk: updatedVoting.kiosk,
                    telephone: updatedVoting.telephone,
                },
            });
        }
    };
    useEffect(function () {
        if (record === null || record === void 0 ? void 0 : record.voting_channels) {
            setVoting(toTenantVotingChannels(record.voting_channels));
        }
    }, [record]);
    if (isLoading)
        return null;
    return (_jsx(SettingsVotingChannelsStyles.Wrapper, { children: Object.keys(voting).map(function (method) { return (_jsxs(SettingsVotingChannelsStyles.Content, { children: [_jsx(SettingsVotingChannelsStyles.Text, { children: t("electionTypeScreen.common.".concat(method, "Voting")) }), _jsx(Switch, { checked: voting[method], onChange: function () { return handleToggle(method); } })] }, method)); }) }));
};
var templateObject_1, templateObject_2, templateObject_3;
